import React from 'react';
import {
  Table,
  TableBody,
  TableContainer,
  TableCell,
  TableRow,
  Paper,
  TableHead,
} from '@material-ui/core';
import { useStyles } from './style';
import { tableChartDataObject } from '../../@types/chartData';

interface Data {
  rows: tableChartDataObject[];
  legends: string[];
}
interface TableData {
  data: Data;
}
const TableChart: React.FC<TableData> = ({ data }) => {
  const styles = useStyles();

  return (
    <TableContainer component={Paper}>
      <Table className={styles.table} aria-label="simple table">
        <TableHead>
          <TableRow className={styles.tableHead}>
            {data.legends.map((legend) => (
              <TableCell key={legend} className={styles.tableCellHead} align="center">
                {legend}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.rows.map((row) => (
            <TableRow key={row.name}>
              <TableCell
                className={styles.tableTh}
                align="center"
                component="th"
                scope="row"
              >
                {row.name}
              </TableCell>
              {row.values.map((value, index) => (
                <TableCell
                  className={styles.tableCell}
                  align="center"
                  key={`${row.name}${value * 3 + index}`}
                >
                  {row.name === 'Total' ? (
                    <p style={{ fontWeight: 'bolder' }}>{value}</p>
                  ) : row.values.indexOf(value) === row.values.length - 1 ? (
                    <p style={{ fontWeight: 'bolder' }}>{value}</p>
                  ) : (
                    value
                  )}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableChart;
